export default __webpack_public_path__ + "resources/icons/n322-8362.png";